module.exports = __webpack_public_path__ + "static/media/mn.2cc43b60.svg";